// extracted by mini-css-extract-plugin
export default {"imageBg":"TermPage_imageBg__+2mWa","sectionWrapper":"TermPage_sectionWrapper__nPyX4","title":"TermPage_title__iT-JA","subTitle":"TermPage_subTitle__iZ7wq"};